// This file is automatically generated during the build process.
export const DIST_VERSION = 'v1.8.1';
